import React from 'react';
import { useApp } from '@/contexts/AppContext';

const ROLES = ['CISO', 'Security', 'Engineering', 'Audit'];

export default function RoleSwitch() {
  const { role, setRole } = useApp();
  return (
    <div data-testid="role-switch" className="hidden lg:inline-flex items-center bg-slate-800 rounded-full p-0.5 gap-0.5 border border-slate-700">
      {ROLES.map((r) => (
        <button
          key={r}
          data-testid={`role-${r.toLowerCase()}`}
          onClick={() => setRole(r)}
          className={`px-3 py-1 text-[11px] font-semibold rounded-full transition-all ${role === r ? 'bg-apex-lens text-white' : 'text-slate-300 hover:text-white'}`}
        >
          {r}
        </button>
      ))}
    </div>
  );
}
